export class IonAlertConstants {
  public static readonly backdrop: string = 'backdrop';
}
